import React from 'react';
import DatePicker from 'material-ui/DatePicker';
import Utils from "../../Utils/Utility";


export default class DatePickerExampleToggle2 extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            minFromDate: '',
            maxFromDate: '',
            minToDate: '',
            maxToDate: '',
            fromDate: '',
            toDate: '',
            autoOk: false,
            disableYearSelection: false,
            defaultDateRangeDays: 100,
            showDatePicker: false,
            fromMessage: '',
            timeZone: null
        };

        this._bind(
          'searchOnSelectedDate'
        );
    }

    _bind(...methods) {
        methods.forEach((method) => this[method] = this[method].bind(this));
    }


    componentWillMount() {

        this.setState({
            timeZone: this.props.timeZone
        });
    }

    componentDidMount() {

        let timeZone = this.state.timeZone;

        // console.log("timeZone:" + timeZone);

        let currentDateTime = Utils.formatDateTimeWithTimeZone(new Date(), timeZone);
        // let maxDateToTimeZone = Utils.formatDateTimeWithTimeZone(new Date(), timeZone);

        let minDate = new Date(currentDateTime);
        let maxDate = new Date(currentDateTime);


        // let defaultFromDateToTimeZone = Utils.formatDateTimeWithTimeZone(new Date(), timeZone);
        // let defaultToDateToTimeZone = Utils.formatDateTimeWithTimeZone(new Date(), timeZone);

        let defaultFromDate = new Date(currentDateTime);
        let defaultToDate = new Date(currentDateTime);


        let allowMinPastYear = this.props.allowMinPastYear ? this.props.allowMinPastYear : 1;

        minDate.setFullYear(minDate.getFullYear() - allowMinPastYear);
        minDate.setHours(0, 0, 0, 0);
        maxDate.setFullYear(maxDate.getFullYear());
        maxDate.setHours(0, 0, 0, 0);

        // startDefaultFromDays = 6 // for a week
        let startDefaultFromDays = this.props.startDefaultFromDays ? this.props.startDefaultFromDays : 6;

        defaultFromDate.setDate(defaultFromDate.getDate() - startDefaultFromDays);
        defaultFromDate.setHours(0, 0, 0, 0);


        defaultToDate.setHours(23, 59, 59, 0);
        this.state = {
            minFromDate: minDate,
            maxFromDate: maxDate,
            minToDate: defaultFromDate,
            maxToDate: maxDate,
            fromDate: defaultFromDate,
            toDate: defaultToDate,
            autoOk: false,
            disableYearSelection: false,
            defaultDateRangeDays: this.props.defaultDateRangeDays,
            showDatePicker: true,
            fromMessage: this.props.fromMessage
        };

    }

    _handleFromDateChange = (event, date) => {

        let timeZone = this.state.timeZone;

        let currentDateTime = Utils.formatDateTimeWithTimeZone(new Date(), timeZone);

        let today = new Date(currentDateTime);
        let toDate = this.state.toDate;

        let selectedDate = new Date(date);
        let maxDate = new Date(date);
        let defaultDays = this.state.defaultDateRangeDays;

        maxDate.setDate(maxDate.getDate() + defaultDays);
        maxDate = maxDate > today ? today : maxDate;

        if (toDate > maxDate) {
            toDate = maxDate;
        }

        if (toDate < selectedDate) {
            toDate = maxDate;
        }

        date.setHours(0, 0, 0, 0);
        toDate.setHours(23, 59, 59,0);

        this.setState({
            fromDate: date,
            toDate: toDate,
            minToDate: date
        });

        // this.props.callBackParent(date, toDate)

    };

    _handleToDateChange = (event, date) => {

        let fromDate = this.state.fromDate;
        let minDate = new Date(date);
        let defaultDays = this.state.defaultDateRangeDays;

        minDate.setDate(minDate.getDate() - defaultDays);

        if (fromDate < minDate) {
            fromDate = minDate;
        }

        date.setHours(23, 59, 59, 0);
        fromDate.setHours(0, 0, 0, 0);

        this.setState({
            toDate: date,
            fromDate: fromDate,
            minToDate: fromDate
        });

        // this.props.callBackParent(fromDate, date);
    };

    searchOnSelectedDate(){
        console.log("fromDate: " + JSON.stringify(this.state.fromDate))
        console.log("toDate: " + JSON.stringify(this.state.toDate))

        this.props.callBackParent(this.state.fromDate, this.state.toDate);
    }

    render() {
        return (
            this.state.showDatePicker ? (
                <div className="col-md-9 no-gutter">
                    <div className="col-xs-12 no-gutter pull-left">
                        <h4 id="translations" className="export-header">{this.state.fromMessage}</h4>
                        {/*<h4><b className={"border-bottom"}>{this.state.fromMessage} :</b></h4>*/}
                    </div>

                    <div className="col-sm-9 no-gutter">
                        <div className="col-sm-3 no-gutter">
                            <div>
                                <p className="mb-0"><b className={"border-bottom"}>Start Date</b></p>
                                <DatePicker
                                    className={this.props.className}
                                    hintText="From Date"
                                    autoOk={this.state.autoOk}
                                    minDate={this.state.minFromDate}
                                    maxDate={this.state.maxFromDate}
                                    disableYearSelection={this.state.disableYearSelection}
                                    onChange={this._handleFromDateChange}
                                    value={this.state.fromDate}
                                />
                            </div>

                        </div>
                        <div className="col-sm-4 no-gutter">
                            <div className="export-date-container">
                                <p className="mb-0"><b className={"border-bottom"}>End Date</b></p>
                                <DatePicker
                                    className={this.props.className}
                                    hintText="To Date"
                                    autoOk={this.state.autoOk}
                                    minDate={this.state.minToDate}
                                    maxDate={this.state.maxToDate}
                                    disableYearSelection={this.state.disableYearSelection}
                                    onChange={this._handleToDateChange}
                                    value={this.state.toDate}
                                />
                            </div>

                        </div>

                        <div className="col-sm-5 no-gutter mt-5 mb-5">
                            <button className={"btn btn-export btn-export-container"} onClick={this.searchOnSelectedDate} ><i className="fa fa-search fa-rotate-90" aria-hidden="true"></i> Search</button>
                        </div>
                    </div>
                </div>


            ) : null

        );
    }
}



// WEBPACK FOOTER //
// src/components/visualization/date-range2.js